export default "__VITE_ASSET__C83zh6hD__"